import React, { useEffect, useState } from 'react'
import CallApi from '../../../data/CallApi';
import { ProfileContent, useProovedorData } from '../../../components';
import { ImagenesGlobal } from '../../../components/global/ImagenesGlobal';
import LimitText from '../../../components/global/LimitText';

import CommentGlobe from '../../../svg/CommentGlobe';
import PlayIcon from '../../../svg/PlayIcon';

/*-------------------------------------------------------*/
import BookmarkIcon from '@mui/icons-material/Bookmark';
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';
/*-------------------------------------------------------*/
import DeleteIcon from '@mui/icons-material/Delete';
/*-------------------------------------------------------*/
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
/*-------------------------------------------------------*/
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ShareIcon from '../../../svg/ShareIcon';
import { useLocation, useNavigate } from 'react-router-dom';

const VideoHighWide = ({ type = 'wide', list_videos = null, allow_white = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { loadImageS, diferenciaFechas, userVideos, videoDataRef } = useProovedorData() ?? [];

  const params = new URLSearchParams(window.location.search);
  const userKey = params.get('authCode');

  const [shortVideoList, setShortVideoList] = useState([]);

  async function listShorts() {
    const path = String(window.location.pathname).substring(0, 6);
    const urlSelected = path != '/video' ? `api/user/video?type=${type}&user_key=${userKey ?? 'me'}` : `api/global/videos?type=${type}`;

    const uk = path != '/video' ? (userKey ?? 'me') : 'global';// user key    

    if (userVideos?.[uk]?.[type]) return setShortVideoList(userVideos?.[uk]?.[type]);

    const request_video = await CallApi({
      url: urlSelected,
      method: 'get'
    });

    if (request_video?.message) return;

    setShortVideoList(request_video);

    userVideos[uk] = userVideos[uk] || {};
    userVideos[uk][type] = request_video;
  }

  const replaceVideo = (file = null) => {
    if (!file) return null;

    return String(file).replace('video', 'preview').replace('mp4', 'webp');
  }

  useEffect(() => {
    if (!list_videos) listShorts();
    else setShortVideoList(list_videos);
  }, [type, list_videos]);

  const addParam = (key = null) => {
    if (!key) return;
    params.set("v", key);

    navigate(`${location.pathname}?${params.toString()}`);
  };

  async function favoriteVideo(videoKey, obj = null) {
    const fetch_like = await CallApi({
      url: `api/user/video/${videoKey}/favorite`,
      method: 'post'
    });

    if (fetch_like?.code != 200) return;

    setShortVideoList((list) => list.map(obj => obj.video_key == videoKey ? ({
      ...obj,
      saves: obj.isFavorite ? (obj.saves - 1) : (obj.saves + 1),
      isFavorite: !obj.isFavorite
    }) : obj));

    const uk = userKey ?? 'me';// user key

    if (userVideos[uk]?.[obj.type]) {
      userVideos[uk][obj.type] = userVideos[uk][obj.type].map(vObj => vObj?.file_name == obj?.file_name ? ({
        ...vObj,
        saves: vObj.isFavorite ? (vObj.saves - 1) : (vObj.saves + 1),
        isFavorite: !vObj.isFavorite
      }) : vObj);
    }


    if (userVideos[uk]?.favorites && obj) {
      if (obj.isFavorite) userVideos[uk].favorites = (userVideos[uk]?.favorites ?? []).filter((list_obj) => list_obj.file_name != obj.file_name)
      else userVideos[uk].favorites = [...(userVideos[uk]?.favorites ?? []), {
        ...obj,
        isFavorite: true
      }];
    }

    if (!videoDataRef?.[videoKey]) return;

    videoDataRef[videoKey] = ({
      ...videoDataRef?.[videoKey],
      saves: videoDataRef?.[videoKey].isFavorite ? (videoDataRef?.[videoKey].saves - 1) : (videoDataRef?.[videoKey].saves + 1),
      isFavorite: !videoDataRef?.[videoKey].isFavorite
    });
  }

  const colorIcons = list_videos && list_videos && allow_white ? 'var(--color-white)' : 'var(--color-fonts-modal)';

  return (
    <ul className={'list-video-user' + (list_videos && allow_white ? ' all-white' : '')}>
      {
        (shortVideoList ?? []).length > 0 ? (
          shortVideoList.map((data) => (
            <li key={data?.video_key}>
              <div className={`lvu-${data?.type ?? type}-img`}>
                <ImagenesGlobal url={data?.file_name ? ('media/' + replaceVideo(data?.file_name)) : null} type='picture' loadImageS={loadImageS} />

                <button className='default-buttons play-icon' onClick={() => addParam(data?.video_key)}>
                  <PlayIcon />
                </button>
              </div>

              <div className='lvu-information-content'>
                <div>
                  <ProfileContent profile_url={data?.profile} loadImageS={loadImageS} style={{ height: 'clamp(40px, 6vw, 52px)' }} />

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <strong>{data?.title}</strong>
                    <span>hace {diferenciaFechas(data?.date)}</span>
                  </div>
                </div>

                <LimitText lineLimit={[4, 8, 10]} style_container={{ flexDirection: 'column', width: '100%', gap: '4px', alignItems: 'start' }}>
                  {data?.description}
                </LimitText>
              </div>

              <div className='lvu-actions' style={list_videos && !allow_white ? { top: '0px' } : {}}>
                <button className='default-buttons' type='button' onClick={() => favoriteVideo(data?.video_key, data)}>
                  {
                    data?.isFavorite ?
                      (<BookmarkIcon style={{ color: 'var(--verde)', fontSize: 'clamp(18px, 2.5vw, 25px)' }} />)
                      :
                      (<TurnedInNotIcon style={{ color: colorIcons, fontSize: 'clamp(18px, 2.5vw, 25px)' }} />)
                  }
                </button>
                {
                  !list_videos && !userKey && (
                    <button className='default-buttons' type='button'>
                      <DeleteIcon style={{ color: 'var(--rojo)', fontSize: 'clamp(18px, 2.5vw, 25px)' }} />
                    </button>
                  )
                }

              </div>

              <div className='lvu-interactions'>
                <span style={{ color: colorIcons }}>
                  {
                    data?.isLiked ?
                      (<FavoriteIcon style={{ fontSize: 'clamp(18px, 2vw, 20px)', color: 'var(--rojo)' }} />)
                      :
                      (<FavoriteBorderIcon style={{ fontSize: 'clamp(18px, 2vw, 20px)', color: colorIcons }} />)
                  }
                  {data?.likes ?? 0}
                </span>

                <span style={{ color: colorIcons }}>
                  <RemoveRedEyeIcon style={{ fontSize: 'clamp(18px, 2vw, 20px)', color: colorIcons }} />
                  {data?.views ?? 0}
                </span>

                <span style={{ color: colorIcons }}>
                  <CommentGlobe color={colorIcons} main_css={{ width: 'clamp(18px, 2vw, 20px)', padding: '0px' }} />
                  {data?.comments ?? 0}
                </span>

                <span style={{ color: colorIcons }}>
                  <ShareIcon color={colorIcons} main_css={{ width: 'clamp(18px, 2vw, 20px)', padding: '0px' }} />
                  {data?.shared ?? 0}
                </span>
              </div>
            </li>
          ))
        ) :
          (
            <li style={{ border: 'none', fontSize: '18px' }}>
              Sin contenido...
            </li>
          )
      }
    </ul>
  )
}

export default VideoHighWide